import { Link } from "react-router-dom";
import { t } from "../lib/i18n";
import { useMe } from "../hooks/useMe";
import { learnerPose, useLearners } from "../hooks/useLearners";
import { Art } from "../ui/Art";

/** "Who is learning today?": the children of this account as big avatar chips. Everything saved afterwards goes to the chosen child. */
export function LearnerPicker() {
  const { me } = useMe();
  const { learners, current, select } = useLearners(Boolean(me));
  if (!me || learners === null) return null;
  if (learners.length === 0) {
    return (
      <Link to="/anak" className="mb-4 flex items-center gap-3 rounded-3xl bg-gradient-to-r from-pink-100 to-amber-100 p-3 shadow-sm ring-1 ring-black/5">
        <Art id="mascot/duo-hello" alt="" className="h-14 w-14 shrink-0" />
        <span className="text-sm font-bold text-slate-800">{t("Tambah profil anak supaya kemajuan setiap anak disimpan dan boleh dipantau.")}</span>
      </Link>
    );
  }
  return (
    <section aria-label={t("Siapa belajar hari ini?")} className="mb-4 rounded-3xl bg-white/80 p-3 shadow-sm ring-1 ring-black/5">
      <p className="mb-2 text-xs font-extrabold uppercase tracking-wide text-slate-500">{t("Siapa belajar hari ini?")}</p>
      <div className="flex flex-wrap gap-2">
        {learners.map((l) => (
          <button key={l.id} type="button" onClick={() => select(l.id)} aria-pressed={current?.id === l.id}
            className={`flex min-h-14 items-center gap-2 rounded-full py-1 pl-1 pr-4 text-left font-extrabold transition active:scale-95 ${current?.id === l.id ? "bg-sky-500 text-white shadow-md" : "bg-sky-50 text-slate-800 ring-1 ring-sky-200"}`}>
            <Art id={`mascot/${learnerPose(l.gender)}`} alt="" className="h-12 w-12 rounded-full bg-white" />
            {l.name}
          </button>
        ))}
        <Link to="/anak" className="flex min-h-14 items-center rounded-full bg-amber-100 px-4 text-sm font-extrabold text-amber-900">{t("Urus anak")}</Link>
      </div>
    </section>
  );
}
